/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class JwtApiBase {
  AccessToken: Promise<string> | undefined

  protected readonly transformOptions = async (options: RequestInit): Promise<RequestInit> => {
    const token = await this.AccessToken

    options.headers = {
      ...options.headers,
      Authorization: `Bearer ${token}`,
    }

    return options
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  public readonly setAccessToken = (token: Promise<string>) => {
    this.AccessToken = token
  }
}

export interface IContentDeliveryClientV2 {

    /**
     * Retrieve a list of Content Metadata
     * @param contentMetadataNames (optional) 
     * @param search (optional) 
     * @param includeBinaries (optional) 
     * @return List of paginated Content Metadata optionally filtered by name
     */
    getContentMetadata(pageNumber: number, pageSize: number, contentMetadataNames: string[] | undefined, search: string | undefined, includeBinaries: boolean | undefined): Promise<ContentMetadata[]>;

    /**
     * Create a new Content Metadata
     * @return Content Metadata successfully created and can be found in the body of the response.
     */
    createContentMetadata(body: ContentMetadataWithoutId): Promise<ContentMetadata>;

    /**
     * Retrieve a single Content Metadata
     * @param contentMetadataId Id of the Content Metadata
     * @return Content Metadata successfully found. Content Metadata can be found in the body.
     */
    getContentMetadataById(contentMetadataId: string): Promise<ContentMetadata>;

    /**
     * Delete a single Content Metadata
     * @param contentMetadataId Id of the content metadata
     * @return Content Metadata successfully deleted.
     */
    deleteContentMetadata(contentMetadataId: string): Promise<void>;

    /**
     * Update a single Content Metadata
     * @param body JSON structure that describes the changes to be made to the ContentMetadata.
     * @return Content Metadata successfully updated.
     */
    updateContentMetadata(contentMetadataId: string, body: ContentMetadataWithoutId): Promise<void>;

    /**
     * Returns content metadata image.
     * @param contentMetadataId Id of the content metadata
     * @param fileName Name of the file (NotificationIcon.png/LibraryCard.png/LibraryHero.png)
     * @param timestamp Encrypted timestamp
     * @return Retrieve the specified blob file
     */
    downloadContentMetadataImage(contentMetadataId: string, fileName: string, timestamp: string): Promise<FileResponse>;

    /**
     * Get a list of all Room Metadata
     * @param companyId (optional) CompanyId to query to get a list of all Room Metadata for a given Company
     * @param contentMetadataId (optional) ContentMetadataId to query to get a list of all Room Metadata for a given ContentMetadata
     * @param tagId (optional) TagId to query to get a list of all Room Metadata for a given Tag
     * @param search (optional) 
     * @param excludeRoomMetadataWithoutContent (optional) Should Room Metadata without Content be ignored
     * @return List of RoomMetadata can be found in the body of the response.
     */
    getRoomMetadata(pageNumber: number, pageSize: number, companyId: string | undefined, contentMetadataId: string | undefined, tagId: string | undefined, search: string | undefined, excludeRoomMetadataWithoutContent: boolean | undefined): Promise<RoomMetadata[]>;

    /**
     * Create Room Metadata for a given Company
     * @return Room Metadata successfully created and can be found in the body of the response.
     */
    createRoomMetadata(body: RoomMetadataWithoutId): Promise<RoomMetadata>;

    /**
     * Retrieve a single Room Metadata
     * @param roomMetadataId Id of the Room Metadata
     * @return Room Metadata successfully found. Room Metadata can be found in the body.
     */
    getRoomMetadataById(roomMetadataId: string): Promise<RoomMetadata>;

    /**
     * Update a single Room Metadata
     * @return Room Metadata successfully updated.
     */
    updateRoomMetadata(roomMetadataId: string, body: RoomMetadataWithoutId): Promise<void>;

    /**
     * Returns room image.
     * @param roomMetadataId Id of the room-metadata
     * @param fileName Name of the file (NotificationIcon.png/LibraryCard.png/LibraryHero.png)
     * @param timestamp Encrypted timestamp
     * @return Retrieve the specified blob file
     */
    downloadRoomMetadataImage(roomMetadataId: string, fileName: string, timestamp: string): Promise<FileResponse>;

    /**
     * Get a list of all Room Metadata given user can access
     * @param companyId (optional) CompanyId to query to get a list of all Room Metadata for a given Company
     * @param contentMetadataId (optional) ContentMetadataId to query to get a list of all Room Metadata for a given ContentMetadata
     * @param tagId (optional) TagId to query to get a list of all Room Metadata for a given Tag
     * @param search (optional) Search string for room
     * @param contentTypes (optional) 
     * @param excludeRoomMetadataWithoutContent (optional) Should Room Metadata without Content be ignored
     * @return List of RoomMetadata can be found in the body of the response.
     */
    getRoomMetadataOfUser(userId: string, pageNumber: number, pageSize: number, companyId: string | undefined, contentMetadataId: string | undefined, tagId: string | undefined, search: string | undefined, contentTypes: string[] | undefined, excludeRoomMetadataWithoutContent: boolean | undefined): Promise<RoomMetadata[]>;

    /**
     * Get FileDescriptors of the given Content Id
     * @param contentId Given Content Id to retrieve files for.
     * @return File Descriptors can be found in the body.
     */
    getFilesOfCurrentUserByContentId(contentId: string, body: ManifestEntry[]): Promise<FileDescriptor[]>;

    /**
     * Get a list of all Room Metadata current user can access
     * @param companyId (optional) CompanyId to query to get a list of all Room Metadata for a given Company
     * @param contentMetadataId (optional) ContentMetadataId to query to get a list of all Room Metadata for a given ContentMetadata
     * @param tagId (optional) TagId to query to get a list of all Room Metadata for a given Tag
     * @param search (optional) search for partial match of name of content
     * @param contentTypes (optional) 
     * @param excludeRoomMetadataWithoutContent (optional) Should Room Metadata without Content be ignored
     * @return List of RoomMetadata can be found in the body of the response.
     */
    getRoomMetadataOfCurrentUser(pageNumber: number, pageSize: number, companyId: string | undefined, contentMetadataId: string | undefined, tagId: string | undefined, search: string | undefined, contentTypes: string[] | undefined, excludeRoomMetadataWithoutContent: boolean | undefined): Promise<RoomMetadata[]>;

    /**
     * Retrieve a single Room Metadata
     * @param roomMetadataId Id of the Room Metadata
     * @return Room Metadata successfully found. Room Metadata can be found in the body.
     */
    getRoomMetadataOfCurrentUserById(roomMetadataId: string): Promise<RoomMetadata>;

    /**
     * Get all spotlight room metadata with order and content Size for current user
     * @return list of all spotlights
     */
    getAllSpotlightsOfCurrentUser(): Promise<Spotlight[]>;

    /**
     * Get all spotlight room metadata with order and content Size
     * @return list of all spotlights
     */
    getAllSpotlights(): Promise<Spotlight[]>;

    /**
     * Create a new spotlight
     * @return spotlight was successfully created.
     */
    createSpotlight(body: SpotlightWithoutId): Promise<Spotlight>;

    /**
     * Get avatar content with files of the user avatars
     * @return Avatar contents can be found in the body.
     */
    getAvatarContentsWithFilesOfUser(avatarType: AvatarType, contentPlatform: ContentPlatform): Promise<ContentWithFiles[]>;

    /**
     * Get a list of all Room Metadata by a User Group
     * @param userGroupId Id of the user group
     * @param requirements (optional) 
     * @param search (optional) 
     * @param excludeRoomMetadataWithoutContent (optional) Should Room Metadata without Content be ignored
     * @return List of RoomMetadata can be found in the body of the response.
     */
    getUserGroupRooms(userGroupId: string, pageNumber: number, pageSize: number, requirements: ContentMetadataRequirements[] | undefined, search: string | undefined, excludeRoomMetadataWithoutContent: boolean | undefined): Promise<RoomMetadataWithRequirements[]>;
}

export class ContentDeliveryClientV2 extends JwtApiBase implements IContentDeliveryClientV2 {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/v2";
    }

    /**
     * Retrieve a list of Content Metadata
     * @param contentMetadataNames (optional) 
     * @param search (optional) 
     * @param includeBinaries (optional) 
     * @return List of paginated Content Metadata optionally filtered by name
     */
    getContentMetadata(pageNumber: number, pageSize: number, contentMetadataNames: string[] | undefined, search: string | undefined, includeBinaries: boolean | undefined): Promise<ContentMetadata[]> {
        let url_ = this.baseUrl + "/content-metadata?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (contentMetadataNames === null)
            throw new Error("The parameter 'contentMetadataNames' cannot be null.");
        else if (contentMetadataNames !== undefined)
            contentMetadataNames && contentMetadataNames.forEach(item => { url_ += "contentMetadataNames=" + encodeURIComponent("" + item) + "&"; });
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (includeBinaries === null)
            throw new Error("The parameter 'includeBinaries' cannot be null.");
        else if (includeBinaries !== undefined)
            url_ += "includeBinaries=" + encodeURIComponent("" + includeBinaries) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetContentMetadata(_response);
        });
    }

    protected processGetContentMetadata(response: Response): Promise<ContentMetadata[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContentMetadata.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request. Failed to parse Content Metadata identifier", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to retrieve this content info", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("No Content Metadata found for given id.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContentMetadata[]>(<any>null);
    }

    /**
     * Create a new Content Metadata
     * @return Content Metadata successfully created and can be found in the body of the response.
     */
    createContentMetadata(body: ContentMetadataWithoutId): Promise<ContentMetadata> {
        let url_ = this.baseUrl + "/content-metadata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateContentMetadata(_response);
        });
    }

    protected processCreateContentMetadata(response: Response): Promise<ContentMetadata> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ContentMetadata.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("ContentMetadataName needs to follow ^{CompanyName}-[a-zA-Z0-9-]+$ and be fewer than 65 characters.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have sufficient permissions to perform this action. You must be an administrator.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("No company data was found with the given company id.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Content Metadata with given name already exists for this Company Id.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContentMetadata>(<any>null);
    }

    /**
     * Retrieve a single Content Metadata
     * @param contentMetadataId Id of the Content Metadata
     * @return Content Metadata successfully found. Content Metadata can be found in the body.
     */
    getContentMetadataById(contentMetadataId: string): Promise<ContentMetadata> {
        let url_ = this.baseUrl + "/content-metadata/{contentMetadataId}";
        if (contentMetadataId === undefined || contentMetadataId === null)
            throw new Error("The parameter 'contentMetadataId' must be defined.");
        url_ = url_.replace("{contentMetadataId}", encodeURIComponent("" + contentMetadataId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetContentMetadataById(_response);
        });
    }

    protected processGetContentMetadataById(response: Response): Promise<ContentMetadata> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContentMetadata.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request. Failed to parse Content Metadata identifier", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to retrieve this content info. You must be an administrator.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("No Content Metadata found for given id.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContentMetadata>(<any>null);
    }

    /**
     * Delete a single Content Metadata
     * @param contentMetadataId Id of the content metadata
     * @return Content Metadata successfully deleted.
     */
    deleteContentMetadata(contentMetadataId: string): Promise<void> {
        let url_ = this.baseUrl + "/content-metadata/{contentMetadataId}";
        if (contentMetadataId === undefined || contentMetadataId === null)
            throw new Error("The parameter 'contentMetadataId' must be defined.");
        url_ = url_.replace("{contentMetadataId}", encodeURIComponent("" + contentMetadataId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteContentMetadata(_response);
        });
    }

    protected processDeleteContentMetadata(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request. Failed to parse Content Metadata identifier", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have sufficient permissions to perform this action. You must be an administrator.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("The ContentMetadata has Content and can\'t get deleted.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Update a single Content Metadata
     * @param body JSON structure that describes the changes to be made to the ContentMetadata.
     * @return Content Metadata successfully updated.
     */
    updateContentMetadata(contentMetadataId: string, body: ContentMetadataWithoutId): Promise<void> {
        let url_ = this.baseUrl + "/content-metadata/{contentMetadataId}";
        if (contentMetadataId === undefined || contentMetadataId === null)
            throw new Error("The parameter 'contentMetadataId' must be defined.");
        url_ = url_.replace("{contentMetadataId}", encodeURIComponent("" + contentMetadataId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateContentMetadata(_response);
        });
    }

    protected processUpdateContentMetadata(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request. Failed to parse Content Metadata identifier also ContentMetadataName needs to follow ^{CompanyName}-[a-zA-Z0-9-]+$.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have sufficient permissions to perform this action. You must be an administrator.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("No Content Metadata found for given id.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Content Metadata with given name already exists for this Company Id.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Returns content metadata image.
     * @param contentMetadataId Id of the content metadata
     * @param fileName Name of the file (NotificationIcon.png/LibraryCard.png/LibraryHero.png)
     * @param timestamp Encrypted timestamp
     * @return Retrieve the specified blob file
     */
    downloadContentMetadataImage(contentMetadataId: string, fileName: string, timestamp: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/content-metadata/{contentMetadataId}/images/{fileName}?";
        if (contentMetadataId === undefined || contentMetadataId === null)
            throw new Error("The parameter 'contentMetadataId' must be defined.");
        url_ = url_.replace("{contentMetadataId}", encodeURIComponent("" + contentMetadataId));
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
        if (timestamp === undefined || timestamp === null)
            throw new Error("The parameter 'timestamp' must be defined and cannot be null.");
        else
            url_ += "timestamp=" + encodeURIComponent("" + timestamp) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadContentMetadataImage(_response);
        });
    }

    protected processDownloadContentMetadataImage(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("No content metadata file found for given id.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Invalid timestamp.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    /**
     * Get a list of all Room Metadata
     * @param companyId (optional) CompanyId to query to get a list of all Room Metadata for a given Company
     * @param contentMetadataId (optional) ContentMetadataId to query to get a list of all Room Metadata for a given ContentMetadata
     * @param tagId (optional) TagId to query to get a list of all Room Metadata for a given Tag
     * @param search (optional) 
     * @param excludeRoomMetadataWithoutContent (optional) Should Room Metadata without Content be ignored
     * @return List of RoomMetadata can be found in the body of the response.
     */
    getRoomMetadata(pageNumber: number, pageSize: number, companyId: string | undefined, contentMetadataId: string | undefined, tagId: string | undefined, search: string | undefined, excludeRoomMetadataWithoutContent: boolean | undefined): Promise<RoomMetadata[]> {
        let url_ = this.baseUrl + "/rooms?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (contentMetadataId === null)
            throw new Error("The parameter 'contentMetadataId' cannot be null.");
        else if (contentMetadataId !== undefined)
            url_ += "contentMetadataId=" + encodeURIComponent("" + contentMetadataId) + "&";
        if (tagId === null)
            throw new Error("The parameter 'tagId' cannot be null.");
        else if (tagId !== undefined)
            url_ += "tagId=" + encodeURIComponent("" + tagId) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (excludeRoomMetadataWithoutContent === null)
            throw new Error("The parameter 'excludeRoomMetadataWithoutContent' cannot be null.");
        else if (excludeRoomMetadataWithoutContent !== undefined)
            url_ += "excludeRoomMetadataWithoutContent=" + encodeURIComponent("" + excludeRoomMetadataWithoutContent) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRoomMetadata(_response);
        });
    }

    protected processGetRoomMetadata(response: Response): Promise<RoomMetadata[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoomMetadata.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to retrieve this room metadata", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoomMetadata[]>(<any>null);
    }

    /**
     * Create Room Metadata for a given Company
     * @return Room Metadata successfully created and can be found in the body of the response.
     */
    createRoomMetadata(body: RoomMetadataWithoutId): Promise<RoomMetadata> {
        let url_ = this.baseUrl + "/rooms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateRoomMetadata(_response);
        });
    }

    protected processCreateRoomMetadata(response: Response): Promise<RoomMetadata> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = RoomMetadata.fromJS(resultData201);
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have sufficient permissions to perform this action.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("No Company Library found for given identifier.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Room with the same MapPath, TagId and ContentMetadataId already exists.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoomMetadata>(<any>null);
    }

    /**
     * Retrieve a single Room Metadata
     * @param roomMetadataId Id of the Room Metadata
     * @return Room Metadata successfully found. Room Metadata can be found in the body.
     */
    getRoomMetadataById(roomMetadataId: string): Promise<RoomMetadata> {
        let url_ = this.baseUrl + "/rooms/{roomMetadataId}";
        if (roomMetadataId === undefined || roomMetadataId === null)
            throw new Error("The parameter 'roomMetadataId' must be defined.");
        url_ = url_.replace("{roomMetadataId}", encodeURIComponent("" + roomMetadataId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRoomMetadataById(_response);
        });
    }

    protected processGetRoomMetadataById(response: Response): Promise<RoomMetadata> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoomMetadata.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request. Failed to parse Room Metadata identifier", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to retrieve this room info", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("No Room Metadata found for given id.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoomMetadata>(<any>null);
    }

    /**
     * Update a single Room Metadata
     * @return Room Metadata successfully updated.
     */
    updateRoomMetadata(roomMetadataId: string, body: RoomMetadataWithoutId): Promise<void> {
        let url_ = this.baseUrl + "/rooms/{roomMetadataId}";
        if (roomMetadataId === undefined || roomMetadataId === null)
            throw new Error("The parameter 'roomMetadataId' must be defined.");
        url_ = url_.replace("{roomMetadataId}", encodeURIComponent("" + roomMetadataId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateRoomMetadata(_response);
        });
    }

    protected processUpdateRoomMetadata(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request. Failed to parse Room Metadata identifier", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have sufficient permissions to perform this action.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("No Company Library or Room Metadata found for given ids.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Room with the same MapPath, TagId and ContentMetadataId already exists.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Returns room image.
     * @param roomMetadataId Id of the room-metadata
     * @param fileName Name of the file (NotificationIcon.png/LibraryCard.png/LibraryHero.png)
     * @param timestamp Encrypted timestamp
     * @return Retrieve the specified blob file
     */
    downloadRoomMetadataImage(roomMetadataId: string, fileName: string, timestamp: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/rooms/{roomMetadataId}/images/{fileName}?";
        if (roomMetadataId === undefined || roomMetadataId === null)
            throw new Error("The parameter 'roomMetadataId' must be defined.");
        url_ = url_.replace("{roomMetadataId}", encodeURIComponent("" + roomMetadataId));
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
        if (timestamp === undefined || timestamp === null)
            throw new Error("The parameter 'timestamp' must be defined and cannot be null.");
        else
            url_ += "timestamp=" + encodeURIComponent("" + timestamp) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadRoomMetadataImage(_response);
        });
    }

    protected processDownloadRoomMetadataImage(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("No room-metadata file found for given id.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Invalid timestamp.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    /**
     * Get a list of all Room Metadata given user can access
     * @param companyId (optional) CompanyId to query to get a list of all Room Metadata for a given Company
     * @param contentMetadataId (optional) ContentMetadataId to query to get a list of all Room Metadata for a given ContentMetadata
     * @param tagId (optional) TagId to query to get a list of all Room Metadata for a given Tag
     * @param search (optional) Search string for room
     * @param contentTypes (optional) 
     * @param excludeRoomMetadataWithoutContent (optional) Should Room Metadata without Content be ignored
     * @return List of RoomMetadata can be found in the body of the response.
     */
    getRoomMetadataOfUser(userId: string, pageNumber: number, pageSize: number, companyId: string | undefined, contentMetadataId: string | undefined, tagId: string | undefined, search: string | undefined, contentTypes: string[] | undefined, excludeRoomMetadataWithoutContent: boolean | undefined): Promise<RoomMetadata[]> {
        let url_ = this.baseUrl + "/users/{userId}/rooms?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (contentMetadataId === null)
            throw new Error("The parameter 'contentMetadataId' cannot be null.");
        else if (contentMetadataId !== undefined)
            url_ += "contentMetadataId=" + encodeURIComponent("" + contentMetadataId) + "&";
        if (tagId === null)
            throw new Error("The parameter 'tagId' cannot be null.");
        else if (tagId !== undefined)
            url_ += "tagId=" + encodeURIComponent("" + tagId) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (contentTypes === null)
            throw new Error("The parameter 'contentTypes' cannot be null.");
        else if (contentTypes !== undefined)
            contentTypes && contentTypes.forEach(item => { url_ += "contentTypes=" + encodeURIComponent("" + item) + "&"; });
        if (excludeRoomMetadataWithoutContent === null)
            throw new Error("The parameter 'excludeRoomMetadataWithoutContent' cannot be null.");
        else if (excludeRoomMetadataWithoutContent !== undefined)
            url_ += "excludeRoomMetadataWithoutContent=" + encodeURIComponent("" + excludeRoomMetadataWithoutContent) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRoomMetadataOfUser(_response);
        });
    }

    protected processGetRoomMetadataOfUser(response: Response): Promise<RoomMetadata[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoomMetadata.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permissions to retrieve rooms for this user", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("User not found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoomMetadata[]>(<any>null);
    }

    /**
     * Get FileDescriptors of the given Content Id
     * @param contentId Given Content Id to retrieve files for.
     * @return File Descriptors can be found in the body.
     */
    getFilesOfCurrentUserByContentId(contentId: string, body: ManifestEntry[]): Promise<FileDescriptor[]> {
        let url_ = this.baseUrl + "/users/me/contents/{contentId}/files";
        if (contentId === undefined || contentId === null)
            throw new Error("The parameter 'contentId' must be defined.");
        url_ = url_.replace("{contentId}", encodeURIComponent("" + contentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFilesOfCurrentUserByContentId(_response);
        });
    }

    protected processGetFilesOfCurrentUserByContentId(response: Response): Promise<FileDescriptor[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDescriptor.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request. Failed to parse ContentId.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to retrieve this Content Files.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Content with given Id was not found or Storage container name does not exist.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDescriptor[]>(<any>null);
    }

    /**
     * Get a list of all Room Metadata current user can access
     * @param companyId (optional) CompanyId to query to get a list of all Room Metadata for a given Company
     * @param contentMetadataId (optional) ContentMetadataId to query to get a list of all Room Metadata for a given ContentMetadata
     * @param tagId (optional) TagId to query to get a list of all Room Metadata for a given Tag
     * @param search (optional) search for partial match of name of content
     * @param contentTypes (optional) 
     * @param excludeRoomMetadataWithoutContent (optional) Should Room Metadata without Content be ignored
     * @return List of RoomMetadata can be found in the body of the response.
     */
    getRoomMetadataOfCurrentUser(pageNumber: number, pageSize: number, companyId: string | undefined, contentMetadataId: string | undefined, tagId: string | undefined, search: string | undefined, contentTypes: string[] | undefined, excludeRoomMetadataWithoutContent: boolean | undefined): Promise<RoomMetadata[]> {
        let url_ = this.baseUrl + "/users/me/rooms?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (contentMetadataId === null)
            throw new Error("The parameter 'contentMetadataId' cannot be null.");
        else if (contentMetadataId !== undefined)
            url_ += "contentMetadataId=" + encodeURIComponent("" + contentMetadataId) + "&";
        if (tagId === null)
            throw new Error("The parameter 'tagId' cannot be null.");
        else if (tagId !== undefined)
            url_ += "tagId=" + encodeURIComponent("" + tagId) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (contentTypes === null)
            throw new Error("The parameter 'contentTypes' cannot be null.");
        else if (contentTypes !== undefined)
            contentTypes && contentTypes.forEach(item => { url_ += "contentTypes=" + encodeURIComponent("" + item) + "&"; });
        if (excludeRoomMetadataWithoutContent === null)
            throw new Error("The parameter 'excludeRoomMetadataWithoutContent' cannot be null.");
        else if (excludeRoomMetadataWithoutContent !== undefined)
            url_ += "excludeRoomMetadataWithoutContent=" + encodeURIComponent("" + excludeRoomMetadataWithoutContent) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRoomMetadataOfCurrentUser(_response);
        });
    }

    protected processGetRoomMetadataOfCurrentUser(response: Response): Promise<RoomMetadata[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoomMetadata.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoomMetadata[]>(<any>null);
    }

    /**
     * Retrieve a single Room Metadata
     * @param roomMetadataId Id of the Room Metadata
     * @return Room Metadata successfully found. Room Metadata can be found in the body.
     */
    getRoomMetadataOfCurrentUserById(roomMetadataId: string): Promise<RoomMetadata> {
        let url_ = this.baseUrl + "/users/me/rooms/{roomMetadataId}";
        if (roomMetadataId === undefined || roomMetadataId === null)
            throw new Error("The parameter 'roomMetadataId' must be defined.");
        url_ = url_.replace("{roomMetadataId}", encodeURIComponent("" + roomMetadataId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRoomMetadataOfCurrentUserById(_response);
        });
    }

    protected processGetRoomMetadataOfCurrentUserById(response: Response): Promise<RoomMetadata> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoomMetadata.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request. Failed to parse Room Metadata identifier", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to retrieve this room info", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("No Room Metadata found for given id.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoomMetadata>(<any>null);
    }

    /**
     * Get all spotlight room metadata with order and content Size for current user
     * @return list of all spotlights
     */
    getAllSpotlightsOfCurrentUser(): Promise<Spotlight[]> {
        let url_ = this.baseUrl + "/users/me/spotlights";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllSpotlightsOfCurrentUser(_response);
        });
    }

    protected processGetAllSpotlightsOfCurrentUser(response: Response): Promise<Spotlight[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Spotlight.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Tag was not found for the RoomMetadata of this Spotlight.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Spotlight[]>(<any>null);
    }

    /**
     * Get all spotlight room metadata with order and content Size
     * @return list of all spotlights
     */
    getAllSpotlights(): Promise<Spotlight[]> {
        let url_ = this.baseUrl + "/spotlights";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllSpotlights(_response);
        });
    }

    protected processGetAllSpotlights(response: Response): Promise<Spotlight[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Spotlight.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Tag was not found for the RoomMetadata of this Spotlight.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Spotlight[]>(<any>null);
    }

    /**
     * Create a new spotlight
     * @return spotlight was successfully created.
     */
    createSpotlight(body: SpotlightWithoutId): Promise<Spotlight> {
        let url_ = this.baseUrl + "/spotlights";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateSpotlight(_response);
        });
    }

    protected processCreateSpotlight(response: Response): Promise<Spotlight> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = Spotlight.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Order cannot be negative.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have sufficient permissions to perform this action.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Room Metadata id was not found or tag id of this Room Metadata was not found or Content was not found for the ContentMetadata of this RoomMetadata.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Spotlight with the same Order already exists.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Spotlight>(<any>null);
    }

    /**
     * Get avatar content with files of the user avatars
     * @return Avatar contents can be found in the body.
     */
    getAvatarContentsWithFilesOfUser(avatarType: AvatarType, contentPlatform: ContentPlatform): Promise<ContentWithFiles[]> {
        let url_ = this.baseUrl + "/users/me/avatars/avatar-content-with-files?";
        if (avatarType === undefined || avatarType === null)
            throw new Error("The parameter 'avatarType' must be defined and cannot be null.");
        else
            url_ += "avatarType=" + encodeURIComponent("" + avatarType) + "&";
        if (contentPlatform === undefined || contentPlatform === null)
            throw new Error("The parameter 'contentPlatform' must be defined and cannot be null.");
        else
            url_ += "contentPlatform=" + encodeURIComponent("" + contentPlatform) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvatarContentsWithFilesOfUser(_response);
        });
    }

    protected processGetAvatarContentsWithFilesOfUser(response: Response): Promise<ContentWithFiles[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContentWithFiles.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Params were badly formed. More information in the body of the response.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to retrieve this content info", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContentWithFiles[]>(<any>null);
    }

    /**
     * Get a list of all Room Metadata by a User Group
     * @param userGroupId Id of the user group
     * @param requirements (optional) 
     * @param search (optional) 
     * @param excludeRoomMetadataWithoutContent (optional) Should Room Metadata without Content be ignored
     * @return List of RoomMetadata can be found in the body of the response.
     */
    getUserGroupRooms(userGroupId: string, pageNumber: number, pageSize: number, requirements: ContentMetadataRequirements[] | undefined, search: string | undefined, excludeRoomMetadataWithoutContent: boolean | undefined): Promise<RoomMetadataWithRequirements[]> {
        let url_ = this.baseUrl + "/user-groups/{userGroupId}/rooms?";
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (requirements === null)
            throw new Error("The parameter 'requirements' cannot be null.");
        else if (requirements !== undefined)
            requirements && requirements.forEach(item => { url_ += "requirements=" + encodeURIComponent("" + item) + "&"; });
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (excludeRoomMetadataWithoutContent === null)
            throw new Error("The parameter 'excludeRoomMetadataWithoutContent' cannot be null.");
        else if (excludeRoomMetadataWithoutContent !== undefined)
            url_ += "excludeRoomMetadataWithoutContent=" + encodeURIComponent("" + excludeRoomMetadataWithoutContent) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserGroupRooms(_response);
        });
    }

    protected processGetUserGroupRooms(response: Response): Promise<RoomMetadataWithRequirements[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoomMetadataWithRequirements.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request. Invalid paging parameters.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to retrieve this room metadata. You must be an administrator.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoomMetadataWithRequirements[]>(<any>null);
    }
}

export class ContentMetadataWithoutId implements IContentMetadataWithoutId {
    contentMetadataName!: string;
    companyId!: string;
    packageName?: string;
    applicationLabel?: string;
    description?: string;
    friendlyName?: string;

    constructor(data?: IContentMetadataWithoutId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contentMetadataName = _data["ContentMetadataName"];
            this.companyId = _data["CompanyId"];
            this.packageName = _data["PackageName"];
            this.applicationLabel = _data["ApplicationLabel"];
            this.description = _data["Description"];
            this.friendlyName = _data["FriendlyName"];
        }
    }

    static fromJS(data: any): ContentMetadataWithoutId {
        data = typeof data === 'object' ? data : {};
        let result = new ContentMetadataWithoutId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ContentMetadataName"] = this.contentMetadataName;
        data["CompanyId"] = this.companyId;
        data["PackageName"] = this.packageName;
        data["ApplicationLabel"] = this.applicationLabel;
        data["Description"] = this.description;
        data["FriendlyName"] = this.friendlyName;
        return data;
    }
}

export interface IContentMetadataWithoutId {
    contentMetadataName: string;
    companyId: string;
    packageName?: string;
    applicationLabel?: string;
    description?: string;
    friendlyName?: string;
}

export class ContentMetadata extends ContentMetadataWithoutId implements IContentMetadata {
    contentMetadataId!: string;
    notificationIconUrl?: string;
    libraryCardUrl?: string;
    libraryHeroUrl?: string;

    constructor(data?: IContentMetadata) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contentMetadataId = _data["ContentMetadataId"];
            this.notificationIconUrl = _data["NotificationIconUrl"];
            this.libraryCardUrl = _data["LibraryCardUrl"];
            this.libraryHeroUrl = _data["LibraryHeroUrl"];
        }
    }

    static fromJS(data: any): ContentMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new ContentMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ContentMetadataId"] = this.contentMetadataId;
        data["NotificationIconUrl"] = this.notificationIconUrl;
        data["LibraryCardUrl"] = this.libraryCardUrl;
        data["LibraryHeroUrl"] = this.libraryHeroUrl;
        super.toJSON(data);
        return data;
    }
}

export interface IContentMetadata extends IContentMetadataWithoutId {
    contentMetadataId: string;
    notificationIconUrl?: string;
    libraryCardUrl?: string;
    libraryHeroUrl?: string;
}

export class RoomMetadataBase implements IRoomMetadataBase {
    contentMetadataId!: string;
    roomName!: string;
    companyId!: string;
    description?: string;
    mapPath!: string;
    replayRecordingType!: ReplayRecordingType;
    maxVisibility!: VisibilityType;
    isSinglePlayer?: boolean;
    isVisibleInMenu?: boolean;
    isHub?: boolean;
    isAugmentedRealityCompatible?: boolean;
    isCreatableByExternalUsers?: boolean;
    allowUserFiles?: boolean;
    allowSinglePlayerMode?: boolean;
    maxUsers?: number;

    constructor(data?: IRoomMetadataBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.allowUserFiles = true;
            this.allowSinglePlayerMode = true;
            this.maxUsers = 20;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contentMetadataId = _data["ContentMetadataId"];
            this.roomName = _data["RoomName"];
            this.companyId = _data["CompanyId"];
            this.description = _data["Description"];
            this.mapPath = _data["MapPath"];
            this.replayRecordingType = _data["ReplayRecordingType"];
            this.maxVisibility = _data["MaxVisibility"];
            this.isSinglePlayer = _data["IsSinglePlayer"];
            this.isVisibleInMenu = _data["IsVisibleInMenu"];
            this.isHub = _data["IsHub"];
            this.isAugmentedRealityCompatible = _data["IsAugmentedRealityCompatible"];
            this.isCreatableByExternalUsers = _data["IsCreatableByExternalUsers"];
            this.allowUserFiles = _data["AllowUserFiles"] !== undefined ? _data["AllowUserFiles"] : true;
            this.allowSinglePlayerMode = _data["AllowSinglePlayerMode"] !== undefined ? _data["AllowSinglePlayerMode"] : true;
            this.maxUsers = _data["MaxUsers"] !== undefined ? _data["MaxUsers"] : 20;
        }
    }

    static fromJS(data: any): RoomMetadataBase {
        data = typeof data === 'object' ? data : {};
        let result = new RoomMetadataBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ContentMetadataId"] = this.contentMetadataId;
        data["RoomName"] = this.roomName;
        data["CompanyId"] = this.companyId;
        data["Description"] = this.description;
        data["MapPath"] = this.mapPath;
        data["ReplayRecordingType"] = this.replayRecordingType;
        data["MaxVisibility"] = this.maxVisibility;
        data["IsSinglePlayer"] = this.isSinglePlayer;
        data["IsVisibleInMenu"] = this.isVisibleInMenu;
        data["IsHub"] = this.isHub;
        data["IsAugmentedRealityCompatible"] = this.isAugmentedRealityCompatible;
        data["IsCreatableByExternalUsers"] = this.isCreatableByExternalUsers;
        data["AllowUserFiles"] = this.allowUserFiles;
        data["AllowSinglePlayerMode"] = this.allowSinglePlayerMode;
        data["MaxUsers"] = this.maxUsers;
        return data;
    }
}

export interface IRoomMetadataBase {
    contentMetadataId: string;
    roomName: string;
    companyId: string;
    description?: string;
    mapPath: string;
    replayRecordingType: ReplayRecordingType;
    maxVisibility: VisibilityType;
    isSinglePlayer?: boolean;
    isVisibleInMenu?: boolean;
    isHub?: boolean;
    isAugmentedRealityCompatible?: boolean;
    isCreatableByExternalUsers?: boolean;
    allowUserFiles?: boolean;
    allowSinglePlayerMode?: boolean;
    maxUsers?: number;
}

export class RoomMetadata extends RoomMetadataBase implements IRoomMetadata {
    roomMetadataId!: string;
    tagName?: string;
    notificationIconUrl?: string;
    libraryCardUrl?: string;
    libraryHeroUrl?: string;

    constructor(data?: IRoomMetadata) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.roomMetadataId = _data["RoomMetadataId"];
            this.tagName = _data["TagName"];
            this.notificationIconUrl = _data["NotificationIconUrl"];
            this.libraryCardUrl = _data["LibraryCardUrl"];
            this.libraryHeroUrl = _data["LibraryHeroUrl"];
        }
    }

    static fromJS(data: any): RoomMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new RoomMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["RoomMetadataId"] = this.roomMetadataId;
        data["TagName"] = this.tagName;
        data["NotificationIconUrl"] = this.notificationIconUrl;
        data["LibraryCardUrl"] = this.libraryCardUrl;
        data["LibraryHeroUrl"] = this.libraryHeroUrl;
        super.toJSON(data);
        return data;
    }
}

export interface IRoomMetadata extends IRoomMetadataBase {
    roomMetadataId: string;
    tagName?: string;
    notificationIconUrl?: string;
    libraryCardUrl?: string;
    libraryHeroUrl?: string;
}

export class RoomMetadataWithRequirements extends RoomMetadata implements IRoomMetadataWithRequirements {
    requirements!: ContentMetadataRequirements;

    constructor(data?: IRoomMetadataWithRequirements) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.requirements = _data["Requirements"];
        }
    }

    static fromJS(data: any): RoomMetadataWithRequirements {
        data = typeof data === 'object' ? data : {};
        let result = new RoomMetadataWithRequirements();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Requirements"] = this.requirements;
        super.toJSON(data);
        return data;
    }
}

export interface IRoomMetadataWithRequirements extends IRoomMetadata {
    requirements: ContentMetadataRequirements;
}

export class RoomMetadataWithoutId extends RoomMetadataBase implements IRoomMetadataWithoutId {
    tagId?: string;
    notificationIcon?: string;
    libraryCard?: string;
    libraryHero?: string;

    constructor(data?: IRoomMetadataWithoutId) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tagId = _data["TagId"];
            this.notificationIcon = _data["NotificationIcon"];
            this.libraryCard = _data["LibraryCard"];
            this.libraryHero = _data["LibraryHero"];
        }
    }

    static fromJS(data: any): RoomMetadataWithoutId {
        data = typeof data === 'object' ? data : {};
        let result = new RoomMetadataWithoutId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TagId"] = this.tagId;
        data["NotificationIcon"] = this.notificationIcon;
        data["LibraryCard"] = this.libraryCard;
        data["LibraryHero"] = this.libraryHero;
        super.toJSON(data);
        return data;
    }
}

export interface IRoomMetadataWithoutId extends IRoomMetadataBase {
    tagId?: string;
    notificationIcon?: string;
    libraryCard?: string;
    libraryHero?: string;
}

export enum ContentMetadataRequirements {
    Optional = "Optional",
    AutoQueue = "AutoQueue",
    Required = "Required",
}

export enum ReplayRecordingType {
    Old = "Old",
    New = "New",
    NotAllowed = "NotAllowed",
}

export enum VisibilityType {
    Public = "Public",
    Internal = "Internal",
    Private = "Private",
}

export class Spotlight implements ISpotlight {
    roomMetadata!: RoomMetadata;
    order!: number;
    contentSize!: number;
    spotlightId!: string;

    constructor(data?: ISpotlight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.roomMetadata = new RoomMetadata();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roomMetadata = _data["RoomMetadata"] ? RoomMetadata.fromJS(_data["RoomMetadata"]) : new RoomMetadata();
            this.order = _data["Order"];
            this.contentSize = _data["ContentSize"];
            this.spotlightId = _data["SpotlightId"];
        }
    }

    static fromJS(data: any): Spotlight {
        data = typeof data === 'object' ? data : {};
        let result = new Spotlight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["RoomMetadata"] = this.roomMetadata ? this.roomMetadata.toJSON() : <any>undefined;
        data["Order"] = this.order;
        data["ContentSize"] = this.contentSize;
        data["SpotlightId"] = this.spotlightId;
        return data;
    }
}

export interface ISpotlight {
    roomMetadata: RoomMetadata;
    order: number;
    contentSize: number;
    spotlightId: string;
}

export class SpotlightWithoutId implements ISpotlightWithoutId {
    roomMetadataId!: string;
    /** Order cannot be negative. */
    order!: number;

    constructor(data?: ISpotlightWithoutId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roomMetadataId = _data["RoomMetadataId"];
            this.order = _data["Order"];
        }
    }

    static fromJS(data: any): SpotlightWithoutId {
        data = typeof data === 'object' ? data : {};
        let result = new SpotlightWithoutId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["RoomMetadataId"] = this.roomMetadataId;
        data["Order"] = this.order;
        return data;
    }
}

export interface ISpotlightWithoutId {
    roomMetadataId: string;
    /** Order cannot be negative. */
    order: number;
}

export enum ContentPlatform {
    Windows = "Windows",
    Android = "Android",
}

export enum AvatarType {
    Stylized = "Stylized",
    Realistic = "Realistic",
}

export class ContentWithFiles implements IContentWithFiles {
    content!: Content;
    files!: FileDescriptor[];

    constructor(data?: IContentWithFiles) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.content = new Content();
            this.files = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["Content"] ? Content.fromJS(_data["Content"]) : new Content();
            if (Array.isArray(_data["Files"])) {
                this.files = [] as any;
                for (let item of _data["Files"])
                    this.files!.push(FileDescriptor.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContentWithFiles {
        data = typeof data === 'object' ? data : {};
        let result = new ContentWithFiles();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Content"] = this.content ? this.content.toJSON() : <any>undefined;
        if (Array.isArray(this.files)) {
            data["Files"] = [];
            for (let item of this.files)
                data["Files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IContentWithFiles {
    content: Content;
    files: FileDescriptor[];
}

export class Content implements IContent {
    contentId!: string;
    releaseId?: string;
    contentMetadataId?: string;
    version!: string;
    unrealEngineVersion?: string | undefined;
    size!: number;
    isIncludedInCoreArtifact!: boolean;
    isStandalone!: boolean;
    contentType!: string;
    updatedAt!: Date;
    buildData?: string | undefined;

    constructor(data?: IContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contentId = _data["ContentId"];
            this.releaseId = _data["ReleaseId"];
            this.contentMetadataId = _data["ContentMetadataId"];
            this.version = _data["Version"];
            this.unrealEngineVersion = _data["UnrealEngineVersion"];
            this.size = _data["Size"];
            this.isIncludedInCoreArtifact = _data["IsIncludedInCoreArtifact"];
            this.isStandalone = _data["IsStandalone"];
            this.contentType = _data["ContentType"];
            this.updatedAt = _data["UpdatedAt"] ? new Date(_data["UpdatedAt"].toString()) : <any>undefined;
            this.buildData = _data["BuildData"];
        }
    }

    static fromJS(data: any): Content {
        data = typeof data === 'object' ? data : {};
        let result = new Content();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ContentId"] = this.contentId;
        data["ReleaseId"] = this.releaseId;
        data["ContentMetadataId"] = this.contentMetadataId;
        data["Version"] = this.version;
        data["UnrealEngineVersion"] = this.unrealEngineVersion;
        data["Size"] = this.size;
        data["IsIncludedInCoreArtifact"] = this.isIncludedInCoreArtifact;
        data["IsStandalone"] = this.isStandalone;
        data["ContentType"] = this.contentType;
        data["UpdatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["BuildData"] = this.buildData;
        return data;
    }
}

export interface IContent {
    contentId: string;
    releaseId?: string;
    contentMetadataId?: string;
    version: string;
    unrealEngineVersion?: string | undefined;
    size: number;
    isIncludedInCoreArtifact: boolean;
    isStandalone: boolean;
    contentType: string;
    updatedAt: Date;
    buildData?: string | undefined;
}

export class ManifestEntry implements IManifestEntry {
    filePath!: string;
    size!: number;
    md5!: string;

    constructor(data?: IManifestEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filePath = _data["FilePath"];
            this.size = _data["Size"];
            this.md5 = _data["Md5"];
        }
    }

    static fromJS(data: any): ManifestEntry {
        data = typeof data === 'object' ? data : {};
        let result = new ManifestEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FilePath"] = this.filePath;
        data["Size"] = this.size;
        data["Md5"] = this.md5;
        return data;
    }
}

export interface IManifestEntry {
    filePath: string;
    size: number;
    md5: string;
}

export class FileDescriptor implements IFileDescriptor {
    filePath!: string;
    size!: number;
    md5!: string;
    uri!: string;
    cdnUri!: string;
    delete!: boolean;

    constructor(data?: IFileDescriptor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.delete = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filePath = _data["FilePath"];
            this.size = _data["Size"];
            this.md5 = _data["Md5"];
            this.uri = _data["Uri"];
            this.cdnUri = _data["CdnUri"];
            this.delete = _data["Delete"] !== undefined ? _data["Delete"] : false;
        }
    }

    static fromJS(data: any): FileDescriptor {
        data = typeof data === 'object' ? data : {};
        let result = new FileDescriptor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FilePath"] = this.filePath;
        data["Size"] = this.size;
        data["Md5"] = this.md5;
        data["Uri"] = this.uri;
        data["CdnUri"] = this.cdnUri;
        data["Delete"] = this.delete;
        return data;
    }
}

export interface IFileDescriptor {
    filePath: string;
    size: number;
    md5: string;
    uri: string;
    cdnUri: string;
    delete: boolean;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

/* tslint:disable */
/* eslint-disable */